import styled from 'styled-components';

const getBorderColor = (isError, isFocused, theme) => {
  if (isError) {
    return theme.defaultColors.error;
  }
  if (isFocused) {
    return theme.customColors.primary;
  }
  return theme.defaultColors.grey;
};

export const getSelectStyles = (theme, error) => ({
  container: (provided) => ({
    ...provided,
    width: '100%',
    minWidth: '70px',
    borderRadius: '3px',
    backgroundColor: error ? theme.defaultColors.errorBackground : theme.defaultColors.white,
  }),
  control: (provided, state) => ({
    ...provided,
    boxShadow: 0,
    borderStyle: 'solid',
    borderWidth: 1,
    borderColor: getBorderColor(state.selectProps.error, state.isFocused, theme),
    borderRadius: '3px',
    fontSize: '16px',
    padding: '0',
    lineHeight: '22px',
    minHeight: '46px',
    opacity: state.isDisabled ? 0.6 : 1,
    backgroundColor: state.selectProps.error
      ? theme.defaultColors.errorBackground
      : theme.defaultColors.white,
    '&:hover': {
      borderColor: theme.primaryColor,
    },
    cursor: 'pointer',
  }),
  indicatorSeparator: () => ({
    display: 'none',
  }),
  option: (provided, state) => ({
    ...provided,
    backgroundColor:
      state.isSelected || state.isFocused ? theme.defaultColors.lighterGrey : '#ffffff',
    paddingLeft: 12,
    fontSize: '16px',
    paddingTop: '6px',
    paddingBottom: '6px',
    lineHeight: '28px',
    borderRadius: '3px',
    color: state.isDisabled ? '#cdcdcd' : theme.defaultColors.fontPrimary,
    cursor: 'pointer',
  }),
  menuList: (provided) => ({
    ...provided,
    padding: 0,
  }),
  multiValue: (provided) => ({
    ...provided,
    margin: '0 6px 6px 0',
    height: '32px',
    alignItems: 'center',
  }),
  multiValueLabel: (provided) => ({
    ...provided,
    padding: 0,
  }),
  valueContainer: (provided, state) => ({
    ...provided,
    minHeight: '32px',
    backgroundColor: state.selectProps.error
      ? theme.defaultColors.errorBackground
      : theme.defaultColors.white,
  }),
  menu: (provided) => ({
    ...provided,
    margin: '-1px 0 0',
    boxShadow: '0px 10px 20px #0000000D',
    border: '1px solid #C1C1C1',
    borderRadius: '3px',
  }),
  noOptionsMessage: (provided) => ({
    ...provided,
    borderRadius: 0,
    background: '#fff',
    textAlign: 'left',
  }),
  input: (provided) => ({
    ...provided,
    padding: 0,
    margin: 0,
  }),
  dropdownIndicator: () => ({
    width: 0,
    height: 0,
    borderStyle: 'solid',
    borderWidth: '4px 3px 0 3px',
    borderColor: '#777777 transparent transparent transparent',
    marginRight: '10px',
  }),
  placeholder: (defaultStyles) => ({
    ...defaultStyles,
    color: '#c1c1c1',
  }),
});

export const StyledMobileSelect = styled.select`
  padding-left: 10px;
  height: 46px;
  width: 100%;
  font-size: 16px;
  line-height: 22px;
  border-radius: 3px;
  border: 1px solid ${({ theme }) => theme.defaultColors.grey};
  color: ${({ theme }) => theme.defaultColors.fontPrimary};
  background: #ffffff;

  appearance: none;
  ::-ms-expand {
    display: none;
  }
  &:disabled {
    opacity: 0.4;
  }
`;

export const StyledMobileWrapper = styled.div`
  position: relative;
  display: flex;

  ::after {
    content: '';
    display: block;
    position: absolute;
    top: calc(50% - 2px);
    right: 12px;
    width: 0px;
    height: 0px;
    border-style: solid;
    border-width: 4px 3px 0px;
    border-color: #444444 transparent transparent;
    margin-left: 10px;
  }
`;

export const FieldBlock = styled.div`
  font-size: 13px;
`;
